import Vue from 'vue';
import Component from 'vue-class-component';
import Snackbar from '@/pages/core/snackbar/snackbar.vue';
import CookieConsent from '@/pages/core/cookie/cookie-consent.vue';
import PromptDialog from '@/pages/core/prompt-dialog/prompt-dialog.vue';
import { Inject } from 'vue-property-decorator';
import AccountService from '@/pages/account/account.service';
import { Authority } from '@/shared/security/authority';

const defaultLayout = 'default-layout';

@Component({
  components: { Snackbar, CookieConsent, PromptDialog },
})
export default class AppLayout extends Vue {
  @Inject('accountService') private accountService: () => AccountService;

  private hasAnyAuthorityValue = false;

  private get layout() {
    const layout = this.$route.meta.layout || defaultLayout;
    return () => import(`@/layouts/${layout}/${layout}.vue`);
  }

  public hasAnyAuthority(authorities: any): boolean {
    this.accountService()
      .hasAnyAuthorityAndCheckAuth(authorities)
      .then(value => {
        this.hasAnyAuthorityValue = value;
      });
    return this.hasAnyAuthorityValue;
  }

  created() {
    for (const auth in Authority) {
      this.hasAnyAuthority(auth);
    }
  }
}
